let newColor = document.getElementById('hero').style.backgroundColor;
let sidebar = document.getElementById('sidebar');
let downloads = document.getElementById('downloads');

if(newColor && sidebar) {
    sidebar.style.backgroundColor = newColor;
}
if(newColor && downloads) {
    downloads.style.backgroundColor = newColor;
}